import AppClass from './../../../../../../js/classes/App.js'

import './styles.scss'

document.addEventListener('DOMContentLoaded', () => {
    const printDate = (item, dateFrom, dateTo) => {
        if (dateTo > dateFrom) {
            let diff = (dateTo - dateFrom) / 1000,
            _diff = Math.abs(Math.floor(diff)),
            d = Math.floor(_diff / (24 * 60 * 60)),
            s = _diff - d * 24 * 60 * 60,
            h = Math.floor(s / (60 * 60))
            
            s = s - h * 60 * 60
            
            let m = Math.floor(s / (60))
            
            s = s - m * 60
            
            if (h < 10) {
                h = '0' + h
            }
            
            if (m < 10) {
                m = '0' + m
            }
            
            if (s < 10) {
                s = '0' + s
            }
            
            item.querySelector('.happy-shares__item-expire').innerHTML = '<span>До завершения:</span> <span>' + AppClass.declension(d, 'день', 'дня', 'дней') + " " + h + ':' + m + ':' + s + '</span>'
            
            item.setAttribute('data-active-from', (parseInt(dateFrom) + 1000))
        } else {
            item.querySelector('.happy-shares__item-expire').innerHTML = '<span class="happy-shares__item-expire-date">Акция завершена</span>'
        }
    }

    document.querySelectorAll('.happy-shares__list .happy-shares__item').forEach((item) => {
        const intervalFunc = () => {
            const activeFrom = parseInt(item.getAttribute('data-active-from')),
            activeTo = parseInt(item.getAttribute('data-active-to'))		
            
            printDate(item, activeFrom, activeTo)
        }
        
        intervalFunc()
        
        setInterval(() => intervalFunc(), 1000)
    })
})

const loadMoreBrandsButton = document.querySelector('.button_load-more-brands')

if (loadMoreBrandsButton) {
    loadMoreBrandsButton.addEventListener('click', () => {
        document.querySelectorAll('.happy-share__brands .happy-share__brands-item.button_hide').forEach((buttonBrand) => {
            buttonBrand.classList.remove('button_hide')
        })

        loadMoreBrandsButton.remove()
    })
}